import Component from './table.vue';
export default Component;
